import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-lcd',
  templateUrl: './lcd.component.html',
  styleUrls: ['./lcd.component.css']
})
export class LcdComponent implements OnInit {

  @Input() digits = 3;
  @Input() size = 40;
  @Input() value = 1;

  constructor() { }

  ngOnInit(): void {
  }

  get lcdStyle(): any {
    return Object.assign(this.fieldStyle, {
      width: `${this.digits * this.size*0.7}px`
    });
  }
  get fieldStyle(): any {
    return {
      height: `${this.size*0.9}px`,
      width: `${this.size*0.6}px`,
    };
  }
  get digitStyle(): any {
    return {
      'margin-left': `${this.size*0.08}px`,
      'margin-top': `${this.size*0.1}px`,
      'font-size': `${this.size*1.1}px`
    };
  }


  get values() {
    return (this.value).toString().padStart(this.digits,'0').split('');
  }
}
